import type {
  ChangePasswordRequest,
  LoginRequest,
  LoginResponse,
  RefreshResponse,
} from '@kreart/shared';
import { api } from '@/lib/api';

export const authApi = {
  login: (body: LoginRequest) =>
    api.post<LoginResponse>('/auth/login', body, { skipAuthRefresh: true }),

  // Undefined (a 204) when nobody is signed in on this browser.
  refresh: () =>
    api.post<RefreshResponse | undefined>('/auth/refresh', undefined, { skipAuthRefresh: true }),

  logout: () => api.post<void>('/auth/logout', undefined, { skipAuthRefresh: true }),

  changePassword: (body: ChangePasswordRequest) =>
    api.post<void>('/auth/change-password', body, { skipAuthRefresh: true }),
};
